function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icons/thumbs-up-border-light");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "icons/thumbs-up-border-light",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "thumbs-up",
  transform: "translate(1.000000, 1.000000)",
  stroke: "currentColor",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.2,7.7 L13.2,3.3 C13.2,1.47746033 11.7225397,-4.4408921e-16 9.9,-4.4408921e-16 L5.5,9.9 L5.5,22.0001426 L17.908,22.0001426 C19.0050154,22.0124018 19.9435073,21.2146837 20.108,20.13 L21.626,10.23 C21.7228616,9.59184085 21.5345869,8.94333968 21.1110444,8.45626577 C20.6875018,7.96919186 20.0714269,7.69269089 19.426,7.7 L13.2,7.7 Z M5.5,22 L2.2,22 C0.98497355,22 0,21.0150264 0,19.8 L0,12.1 C0,10.8849736 0.98497355,9.9 2.2,9.9 L5.5,9.9 L5.5,22 Z",
  id: "Shape"
})));

var SvgThumbsUpBorder = function SvgThumbsUpBorder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThumbsUpBorder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thumbs-up-border.7a4ec907.svg";
export { ForwardRef as ReactComponent };